import { render } from "./DownloadApplication.vue?vue&type=template&id=81409030&scoped=true"
const script = {}

import "./DownloadApplication.vue?vue&type=style&index=0&id=81409030&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81409030"]])

export default __exports__